import React from 'react';
import { observer } from 'mobx-react';
import { ExpandRightIcon, Typography, sizeVars } from '@routific/hive/v5';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/mst';
import { VisitDtoModelType } from '../../store/mst/models';
import { Pages } from '../../store/mst/Router/constants';

interface Props {
  visit: VisitDtoModelType;
  stopUuid?: string;
}

const InlineDiv = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${sizeVars.space[50]};
  width: inherit;
  max-width: 100%;
`;

const GrowDiv = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
`;

const StaticDiv = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
`;

const ScheduledTo: React.FC<Props> = ({ visit, stopUuid }) => {
  const { t } = useTranslation('common');
  const store = useStore();
  const { router, model } = store;

  const navigateToRoute = () => {
    router.navigateToRouteResource({ routeUuid: visit.route?.uuid }, { targetPage: Pages.SCHEDULING, deselectStop: true, deselectOrder: true });
  };

  const navigateToStop = () => {
    router.navigateToRouteResource({ routeUuid: visit.route?.uuid, stopUuid }, { targetPage: Pages.SCHEDULING, deselectOrder: true });
  };

  const sequence = stopUuid ? model.latestStopSequence(stopUuid) : visit.timeline?.stopSequence;

  return (
    <InlineDiv>
      <GrowDiv>
        <Typography
          variant="link"
          onClick={() => navigateToRoute()}
          data-cy="back-to-route-button"
          truncate
        >
          {visit.route?.name}
        </Typography>
      </GrowDiv>
      <StaticDiv>
        <ExpandRightIcon size="sm" tone="secondary" />
      </StaticDiv>
      <StaticDiv>
        <Typography
          variant="link"
          onClick={() => navigateToStop()}
          data-cy="back-to-route-event-button"
        >
          {t('stop.sequence', { sequence: sequence })}
        </Typography>
      </StaticDiv>
    </InlineDiv>
  );
};

export default observer(ScheduledTo);
